// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.family_info{margin-top:1%}`, "",{"version":3,"sources":["webpack://./app/src/scenes/study-page/create-study/analysis-page/components/samples-section/selection_container.css"],"names":[],"mappings":"AAIA,aACI,aAAA","sourcesContent":["\n\n\n\n.family_info {\n    margin-top: 1%;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
